import { render, staticRenderFns } from "./dataDetailsTab.vue?vue&type=template&id=6dbb83c0&scoped=true"
import script from "./dataDetailsTab.vue?vue&type=script&lang=js"
export * from "./dataDetailsTab.vue?vue&type=script&lang=js"
import style0 from "./dataDetailsTab.vue?vue&type=style&index=0&id=6dbb83c0&prod&lang=scss&scoped=true"
import style1 from "./dataDetailsTab.vue?vue&type=style&index=1&id=6dbb83c0&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6dbb83c0",
  null
  
)

export default component.exports